/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#shared/api/client'
import type { DeletePasskeyOptions, DeletePasskeyResponses } from '../models/DeletePasskey'
import { client } from '#shared/api/client'

/**
 * @summary Deletes one of the account's passkeys, never its last one.
 * {@link /api/passkeys/:id}
 */
export function deletePasskey<ThrowOnError extends boolean = true>(options: Options<DeletePasskeyOptions, ThrowOnError>): Promise<RequestResult<DeletePasskeyResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'DELETE', url: '/api/passkeys/{id}', security: [{ type: 'apiKey', name: 'cas_session', in: 'cookie' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<DeletePasskeyResponses, ThrowOnError>>
}
